import { Mail, Phone, MapPin, Clock } from "lucide-react";
import { PolicyLayout } from "@/components/PolicyLayout";

const cards = [
  { icon: Mail, label: "Email", value: "support@crazyone.app", href: "mailto:support@crazyone.app" },
  { icon: Phone, label: "Phone", value: "+91 90000 00000", href: "tel:+919000000000" },
  { icon: Clock, label: "Support hours", value: "Mon–Sat, 10:00–19:00 IST" },
  { icon: MapPin, label: "Address", value: "crazyOne, Bengaluru, Karnataka, India" },
];

export default function Contact() {
  return (
    <PolicyLayout title="Contact Us" testId="page-contact">
      <p>
        Have a question about the crazyOne app store, a subscription, a payment, or a refund? We're here to help. Reach us
        through any of the channels below and our team will respond as quickly as possible.
      </p>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {cards.map((c) => (
          <div key={c.label} data-testid={`contact-${c.label.toLowerCase().replace(/\s/g, "-")}`} className="flex items-start gap-3 rounded-xl border border-[#1E2433] bg-[#10131B] p-4">
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-emerald-500/20 bg-emerald-500/10 text-emerald-400">
              <c.icon className="h-5 w-5" />
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-wider text-slate-500">{c.label}</p>
              {c.href ? (
                <a href={c.href} className="text-base font-semibold text-slate-100 hover:text-emerald-400">{c.value}</a>
              ) : (
                <p className="text-base font-semibold text-slate-100">{c.value}</p>
              )}
            </div>
          </div>
        ))}
      </div>

      <h2>Business / merchant details</h2>
      <p>
        crazyOne operates this digital distribution platform and processes subscription payments in Indian Rupees (INR ₹)
        through Cashfree Payments. For billing or payment-gateway related queries, please include your order ID
        (format <span className="font-mono text-emerald-400">co_xxxxxxxx</span>) in your message so we can assist you faster.
      </p>
    </PolicyLayout>
  );
}
